import { render } from "./Dish.vue?vue&type=template&id=86ae1186&scoped=true"
import script from "./Dish.vue?vue&type=script&lang=js"
export * from "./Dish.vue?vue&type=script&lang=js"

import "./Dish.vue?vue&type=style&index=0&id=86ae1186&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86ae1186"]])

export default __exports__